import type { ReactNode } from 'react';
import type { WorkspaceShellContentSlots, WorkspaceShellServices } from './workspaceShellTypes.js';

export function renderProfessionalWorkspaceShell(slots: WorkspaceShellContentSlots, services: WorkspaceShellServices): ReactNode {
  const { drawingFocusMode, navOpen, setNavOpen } = services;
  return (
    <>
      {slots.mobileToggle}
      {slots.mobileScrim}
      <div className={drawingFocusMode ? 'hidden' : `fixed inset-y-0 left-0 z-[50] max-h-[100dvh] overflow-y-auto transition-transform duration-300 md:static md:z-auto md:max-h-none md:overflow-visible md:translate-x-0 ${navOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        {slots.sidebar}
      </div>
      <div className="flex flex-col flex-1 min-w-0" data-testid="professional-workspace-shell">
        {slots.healthBanner}
        {slots.topBar}
        {slots.upsell}
        {slots.routeContent}
        {slots.footer}
      </div>
      {slots.pfeMount}
      {slots.ingestMount}
      {slots.launcher}
      {slots.intercom}
      {slots.avatarOverlay}
      {slots.focusBeamExit}
      {slots.windowManager}
    </>
  );
}
